<div fxLayout="column" fxLayoutGap="20px">
  <div fxLayoutAlign="space-between center">
    <h1>Usuários externos</h1>
    <div>
      <button mat-raised-button color="primary" routerLink="/usuario-externo/cadastro">
        <mat-icon>add</mat-icon> Adicionar
      </button>
    </div>
  </div>

  <app-search-input #searchInput (search)="search($event)" placeholder=""></app-search-input>

  <div>
    <table mat-table [dataSource]="dataSource" matSort matSortActive="nome" matSortDirection="asc">
      <ng-container matColumnDef="idUsuario">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>#</th>
        <td mat-cell *matCellDef="let row">{{ row.idUsuario }}</td>
      </ng-container>
      <ng-container matColumnDef="nome">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
        <td mat-cell *matCellDef="let row">{{ row.nome }}</td>
      </ng-container>
      <ng-container matColumnDef="cpf">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CPF</th>
        <td mat-cell *matCellDef="let row">{{ row.cpf | mask : '000.000.000-00' }}</td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let row">{{ row.email }}</td>
      </ng-container>
      <ng-container matColumnDef="identificacao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Identificação</th>
        <td mat-cell *matCellDef="let row">{{ row.identificacao }}</td>
      </ng-container>
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let row; let i = index" class="w-215">
          <button mat-icon-button color="basic" routerLink="/usuario-externo/cadastro/{{ row.cpf }}" title="Editar">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="6">
          <app-table-no-data [searchValue]="searchInput.value"></app-table-no-data>
        </td>
      </tr>
    </table>
    <app-default-paginator #paginator></app-default-paginator>
  </div>
</div>
